import React from 'react';
import withRouter from 'react-router-dom/withRouter';
import inView from 'in-view';
import imgData from '../data/imgData';
import find from 'lodash/find';
import queryString from 'query-string'
//inView.threshold(0.5);

class Section extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.changeLinkAllowed = true;
  }

  onInView( el ){
      const { id, history, location } = this.props;
      const locationId = location.pathname.split('/')[1];
      const query = queryString.parse(location.search||"?l=it");
      const languageID = query.l || "it";
      const menuLink = query.menu == "true";
      if( id == locationId || !menuLink ){
        history.push(`/${id}?l=${languageID}`);
      }
  }

  componentDidMount() {
    const { id } = this.props;
    //console.log( inView( `.${id}` ) );
    //inView( `.${id}` ).options.offset= { top: 10 , right: 0, bottom: 0 , left: 0 }
    inView( `.${id}` ).options.threshold = 0.3;
    inView( `.${id}` ).on( 'enter', this.onInView.bind(this) );
  }

  render() {
    const { children, id } = this.props;
    const image = find( imgData, img => img.id == id );
    return (
      <div className={`section ${id}`} >
        <div className="picture" style={ image? { backgroundImage: `url('${image.src}')` }:{} } />
        <div className="content">
          { children }
        </div>
      </div>
    );
  }
}

export default withRouter( Section );



// WEBPACK FOOTER //
// ./src/components/Section.js